import { render, staticRenderFns } from "./TaskDealModal.vue?vue&type=template&id=232473f6&scoped=true&"
import script from "./TaskDealModal.vue?vue&type=script&lang=js&"
export * from "./TaskDealModal.vue?vue&type=script&lang=js&"
import style0 from "./TaskDealModal.vue?vue&type=style&index=0&id=232473f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232473f6",
  null
  
)

export default component.exports